import {TOKEN_NAME_MAPPING, TOKENS, TOKENS_RELIED_ON_QUARTER} from "../../../constants/tokens";
import {checkIfAnyQuarter} from "../../buildings/checkIfAnyQuarter";
import {calculateBlockedConstructionCellsForCentralQuarter} from "./calculateBlockedConstructionCellsForCentralQuarter";
import {checkIfCentralQuarter} from "../../buildings/checkIfCentralQuarter";
import {calculateBlockedConstructionCellsForBaseQuarter} from "./calculateBlockedConstructionCellsForBaseQuarter";
import {
  calculateBlockedConstructionCellsForBuildingsReliedOnQuarter
} from "./calculateBlockedConstructionCellsForBuildingsReliedOnQuarter";
import {calculateBlockedConstructionCellsForRoads} from "./calculateBlockedConstructionCellsForRoads";

/**
 * Рассчитывает ячейки, на которых запрещено строительство
 *
 * @param selectedToken
 * @param hexes
 * @param citiesCache
 * @param currentPlayerColor
 * @param {Array<string>} availableConstructionCells - ячейки доступные для строительства
 */

export const calculateBlockedConstructionCells = (selectedToken, hexes, citiesCache, currentPlayerColor, availableConstructionCells) => {
  if (checkIfAnyQuarter(selectedToken)) {
    const [blockedCellsForCentralQuarter, blockedCellsForCentralQuarterBySelf, blockedCellsForCentralQuarterByEnemies] =
      calculateBlockedConstructionCellsForCentralQuarter(hexes, citiesCache, currentPlayerColor, availableConstructionCells);

    if (checkIfCentralQuarter(selectedToken)) {
      return {
        blockedCellsErrorMessage: 'Кварталы нельзя строить ближе 2 ячеек от кварталов других городов',
        blockedCells: blockedCellsForCentralQuarter
      };
    } else {
      return {
        blockedCellsErrorMessage: 'Кварталы нельзя строить ближе 2 ячеек от кварталов других городов',
        blockedCells: calculateBlockedConstructionCellsForBaseQuarter(
          hexes, citiesCache, currentPlayerColor, blockedCellsForCentralQuarterBySelf, blockedCellsForCentralQuarterByEnemies
        )
      };
    }
  } else if (TOKENS_RELIED_ON_QUARTER.includes(selectedToken)) {
    const tokenName = TOKEN_NAME_MAPPING[selectedToken];

    return {
      blockedCellsErrorMessage: `${tokenName} - нельзя строить смежно кварталам противника`,
      blockedCells: calculateBlockedConstructionCellsForBuildingsReliedOnQuarter(
        citiesCache, currentPlayerColor, availableConstructionCells
      )
    };
  } else if (selectedToken === TOKENS.ROAD) {
    return {
      blockedCellsErrorMessage: 'Дорога на этой ячейке уже построена',
      blockedCells: calculateBlockedConstructionCellsForRoads(
        hexes, availableConstructionCells
      )
    };
  }

    return {
      blockedCellsErrorMessage: 'Неизвестная ошибка',
      blockedCells: new Set()
    };
};
